module.exports = __webpack_public_path__ + "img/hr-ccm-universal-04h-green-LED-sequence.3ac85ff2.png";